import { useSubscribeDOMDestroyed } from "../observer/useDomObserver";
import ReactiveZone from "../ReactiveZoneClass";
import { htmlToNodes, parseHTML } from "../templateBuilder/util";
import useMarkIsCustomComponent, { removeMarkCustomComponent } from "../templateBuilder/utils/useMarkIsCustomComponent";
import { useReactiveZone } from "../useReactiveZone";
import useMap from "../utils/useMap";
import useWeakMap from "../utils/useWeakMap";

/**
 * @type {Map<string,Node>}
 */
const store = useMap();
const storeCustomNode = useWeakMap();

const rendered = new Set();


const createCustomComponent = (name, onInit, onConnected, onDisconnected) => {
    if (customElements.get(name)) return;

    const component = class extends HTMLElement {

        constructor() {
            super();
            onInit(this)
        }

        connectedCallback() {
            onConnected.call(this, this);
        }

        disconnectedCallback() {
            onDisconnected.call(this, this);
        }

    };
    window.customElements.define(name, component);
    return component;
}

/**
 * 
 * @param {Node} node 
 */
export const checkIsComponent = (node) => {
    if (store.has(node.nodeName.toLowerCase())) {
        return true;
    }

};

const instance = (name, options) => {

    /**
     * 
     * @param {HTMLElement} node 
     * @param {*} html 
     * @returns {Array<Node>}
     */
    const replaceNode = (node, html) => {
        const nodeList = htmlToNodes(html);
        const fragment = document.createDocumentFragment();
        const nodes = []
        while (nodeList.length > 0) {
            nodes.push(nodeList[0]);
            fragment.appendChild(nodeList[0]);
        }
        node.parentNode.replaceChild(fragment, node);
        return nodes;
    }
    const initNode = (node) => {
        if (rendered.has(node)) return;
        rendered.add(node);
        const fn = store.get(name);
        /**@type {ReactiveZone} */
        const reactiveZone = useReactiveZone();
        const originUseTemplate = reactiveZone.useTemplate;

        reactiveZone.useTemplate = (opt) => {
            let target = node;
            if (options.replacement) {
                target = replaceNode(node, opt.template);
                opt.template = '';
                for (let i in target) {
                    useMarkIsCustomComponent(target[i]);
                    useSubscribeDOMDestroyed(target[i], () => {
                        removeMarkCustomComponent(target[i])
                    })
                }
            } else {
                useMarkIsCustomComponent(target);
            }
            opt.applyRoot = target;
            originUseTemplate(opt);
        }

        const customUseReactiveZone = () => reactiveZone;

        if (typeof fn === 'function') {
            fn.call(null, customUseReactiveZone);
        }
    }

    const renderNode = (node) => {

    }

    const disconnectNode = (node) => {
        store.delete(node);
        removeMarkCustomComponent(node)
    }

    const component = createCustomComponent(name, initNode, renderNode, disconnectNode)

    const elements = document.querySelectorAll(name);
    if (elements.length > 0) {
        elements.forEach(elm => {
            renderNode(elm);
        })
    }
}

/**
 * 
 * @returns 
 */
const useDefineComponent = (name, fnComponent, options = { replacement: false }) => {
    if (name === undefined) return;
    if (store.has(name)) throw `[useDefineComponent] ${name} alrealy used. Try another`

    store.set(name, fnComponent);
    return instance(name, options)
};

export default useDefineComponent;